import React from 'react';
import NavLinks from '../../NavLinks';
import Ethnicity from './Ethnicity';

const EthnicityU16 = () => 
    <Ethnicity navigateLink={NavLinks.ATHLETE_COMP_GENDER_U16} />

export default EthnicityU16;